/** BroadcastChannel 事件名常量 */
export const BROADCAST_EVENTS = {
  /** 用户切换事件 */
  USER_CHANGE: 'wegic_user_change',
} as const;

export interface UserChangeMessage {
  userId: string;
}

export interface BroadcastMessage<T> {
  type: typeof BROADCAST_EVENTS[keyof typeof BROADCAST_EVENTS];
  data: T;
}
